export default __webpack_public_path__ + "static/media/puggymobile.3756e490.png";